import React, { useState, useEffect, useContext } from 'react';
import { AppContext } from '../../../context';
import { Row, Col, Button } from 'reactstrap';
import { notify } from '../../../utils';
import Switch from 'rc-switch';
import apiClient from '../../../apiClient';

export default function ManageCache () {

    const [timer, setTimer] = useState(false);

    const clearCaches = async () => {
        const res = await apiClient.post('/clearCaches');
        if (res.status === 200) {
            notify('All caches cleared');
        }
    }

    useEffect(() => {
        if (timer) {
            const interval = setInterval(() => {
                clearCaches();
            }, 15000);
        
            return () => {
                clearInterval(interval);
            }
        }
    }, [timer]);

    return (
        <Row>
            <Col md={3}>
                <Button onClick={() => clearCaches()}>Clear Cache</Button>
            </Col>
            <Col md={6}>
                <h3>Automatic 15 second interval</h3>
                <Switch 
                    className={"custom-switch custom-switch-primary"}
                    checked={timer}
                    onChange={() => setTimer(prev => !prev)}
                />
            </Col>
        </Row>
    );
}